export default "__VITE_ASSET__C1B41sqZ__"